import React from "react";

const MyLayers = ({ children }) => {
	return <div>{children}</div>;
};

export default MyLayers;